import { Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { PageSection } from "../../components/PageSection";

export function NotFound() {
  return (
    <PageSection overline="Erro 404" title="Página não encontrada" subtitle="O endereço que você acessou não existe.">
      <Box sx={{ textAlign: "center" }}>
        <Button component={RouterLink} to="/" variant="contained" size="large">
          Voltar para a Home
        </Button>
      </Box>
    </PageSection>
  );
}
